<template>

    <div>
        <div class="form-group">

            <label class="media-label">{{ language.add_type_media_legend }}</label>
            <input style="display: none;" type="file" accept="image/png, image/jpeg" class="form-control-file" id="popupfile" v-on:change="getMediaFile">

            <div class="image-editor-container">
                <button v-if="editable" class="btn btn-primary" v-on:click.prevent="globalFunctions.addImageFile('popup')">{{ language.add_type_choose_file }}</button>
                <img id="media-image" class="preview-image" v-if="dataStore.popUpMediaFile" :src="globalFunctions.getMediaImageUrl(dataStore.popUpMediaFile)" />
            </div>

        </div>

        <div v-if="dataStore.questionType === 'goodbad' && editable" class="allow-image-upload">
            <div class="form-check">
                <input type="checkbox" class="allow-image-upload form-check-input" v-model="dataStore.allowUploadImage" id="allow-image-upload-image">
                <label class="form-check-label" for="allow-image-upload-image">{{ language.add_type_allow_image }}</label>
            </div>
        </div>

        <div v-if="dataStore.questionType === 'goodbad' && editable" class="limit-markers">
            <div class="form-check">
                <input type="checkbox" class="allow-image-upload form-check-input" v-model="dataStore.allowLimitMarkers" id="limit-markers">
                <label class="form-check-label" for="limit-markers">{{ language.add_type_limit_markers }}</label>
            </div>
        </div>

        <div v-if="dataStore.questionType === 'goodbad' && editable && dataStore.allowLimitMarkers" class="col-12 range-control">
            <input type="range" min="1" max="20" v-model="dataStore.amountAnswers" class="control" id="amount-answers">
            <label for="amount-answers"> {{ language.add_type_limit_amount.replacePlaceholders({ number : dataStore.amountAnswers }) }}</label>
        </div>

        <label v-if="editable && dataStore.questionType === 'goodbad'" class="media-label with-divider">{{ language.add_type_qualities }}</label>

        <div v-if="editable && dataStore.questionType === 'goodbad'" class="checkbox-multi form-group">
            <label for="add-good-options"><input v-if="editable" type="checkbox" v-model="dataStore.allowGoodOptions" class="form-check-input" id="allow-good-options"> {{ language.add_type_good }}</label>
            <label for="add-bad-options"><input v-if="editable" type="checkbox" v-model="dataStore.allowBadOptions" class="form-check-input" id="allow-bad-options"> {{ language.add_type_bad }}</label>
        </div>

        <div v-if="editable && dataStore.questionType === 'goodbad'" class="custom-hint image form-group">
            <label for="custom-hint" class="media-label">{{ language.add_type_hint_image }}</label>
            <input type="text" v-model="dataStore.hint" class="form-control" id="custom-hint" />
        </div>

        <div v-if="editable && dataStore.questionType === 'goodbad'" class="row">
            <response-form-description v-model="dataStore.responseFormDescription" :type="'image'" :custom-label="language.text_response_box"></response-form-description>
        </div>

        <div v-if="dataStore.questionType === 'goodbad' && editable" class="form-group save-buttons">
            <button class="btn btn-primary" v-on:click.prevent="addOther($event)">{{ language.add_type_save }}</button>
            <a class="cancel" href="#" v-on:click.prevent="globalFunctions.toggleAddMedia">{{ language.add_type_cancel }}</a>
        </div>

    </div>

</template>

<script>

import dataStore from '../../store'

import globalFunctions from '../../globalFunctions'

import { Fragment } from 'vue-fragment'


import ResponseFormDescription from '../common/ResponseFormDescription.vue'

export default {

    data() {
        return {
            dataStore,
            globalFunctions,
        }
    },

    inject: [ 'language', 'superadmin' ],

    computed: {
        editable: function() {
            return this.superadmin ? true : ( this.dataStore.project.allowToEdit && this.dataStore.isLoaded )
        }
    },

    components: {
        Fragment,
        ResponseFormDescription
    },

    methods: {
        

        getMediaFile: function(e) {
            this.dataStore.activeFileName = e.target.files[0].name;
            this.createImage(e.target.files[0],'dataStore.popUpMediaFile');
        },

        createImage(file, propName) {

            let reader = new FileReader();
            let vm = this;

            if(propName.includes('dataStore')){
                let parts = propName.split('.');
                reader.onload = (e) => {
                    vm[parts[0]][parts[1]] = e.target.result;
                };
            } else {
                reader.onload = (e) => {
                    vm[propName] = e.target.result;
                };
            }

            reader.readAsDataURL(file);
        },

        addOther: function(event) {

            event.target.disabled = true;

            let old = this.dataStore.projectItems[this.dataStore.activeIndex];

            let otherObject = {
                activeType : this.dataStore.activeType,
                questionType : this.dataStore.questionType,
                name : this.dataStore.activeFileName,
                allowUploadImage : this.dataStore.allowUploadImage,
                allowLimitMarkers : this.dataStore.allowLimitMarkers,
                amountAnswers : this.dataStore.amountAnswers,
                allowGoodOptions : this.dataStore.allowGoodOptions,
                allowBadOptions : this.dataStore.allowBadOptions,
                hint : this.dataStore.hint,
                responseFormDescription : this.dataStore.responseFormDescription
            };

            if(old && old.hasOwnProperty("id")) {
                otherObject.id = old.id;
                otherObject.question = old.question;
            }

            console.log('otherObject', otherObject)

            if(this.dataStore.editMode) {

                if(typeof(this.dataStore.popUpMediaFile) === 'string' && this.dataStore.popUpMediaFile.includes('data:image/') ){
                    otherObject.file = this.dataStore.popUpMediaFile;
                } else {
                    if(old.hasOwnProperty('file')){
                        otherObject.file = old.file;
                    } else {
                        otherObject.assets = old.assets;
                    }
                }

                this.globalFunctions.toggleAddMedia(this.dataStore.questionType, true);
                otherObject.updated = true;
                this.dataStore.projectItems.splice( this.dataStore.activeIndex, 1, otherObject );

            } else {
                otherObject.file = this.dataStore.popUpMediaFile;
                this.dataStore.projectItems.push(otherObject)
                this.globalFunctions.toggleAddMedia();
            }

            event.target.disabled = false;

        },

    }
};
</script>
